export enum AuditState {
  NotStarted,
  Started,
  Finished
}
